import { Component, OnInit, AfterViewChecked } from '@angular/core';
import { ApiServicesService } from 'src/app/services/apiServices/api-services.service';
import { API_ROUTES } from 'src/app/core/_constants/api-route.constant';
import { ActivatedRoute, Router } from "@angular/router";
import { RouteConstant } from "src/app/core/_constants/route.constant";
import { EditEnquiryComponent } from 'src/app/modules/pages/profile/edit-enquiry/edit-enquiry.component';
declare var $: any;

@Component({
  selector: 'app-testimonials',
  templateUrl: './testimonials.component.html',
  styleUrls: ['./testimonials.component.scss']
})
export class TestimonialsComponent implements OnInit, AfterViewChecked {
  products: any[] = []; // Ensure it's an array
  homeListdata: any; 
  viewHomeProd: any = "/" + RouteConstant.main + "/" + RouteConstant.marketPlaceList + "/" + RouteConstant.marketplaceProductDetail;
  dialogRef: any;
  toastr: any;
  constructor(private service: ApiServicesService, private router: Router,) { }
  ngAfterViewChecked(): void {
   
  }
  ngOnInit(): void {
    this.homeList();
  }

  ngAfterViewInit(): void {
    // Initialize Slick Slider after the view has been rendered
   


  }


  homeList(nextPageUrl?: string) {
    const apiEndpoint = nextPageUrl || API_ROUTES.HomeList.HomeListing;
  
    this.service.get({}, apiEndpoint).subscribe({
      next: (res: { success: any; result: any; next?: string }) => {
        if (res && res.success && res.result) {
          this.homeListdata = res.result;
  
          // Load next page if available
          if (res.next) {
            this.homeList(res.next); // call the same function with next page URL
          }
  
          // Ensure slick slider is re-initialized after data is loaded
          setTimeout(() => this.initSlick(), 0);
        } else {
          console.warn('API response does not contain success or result');
        }
      },
      error: (error: any) => {
        console.error('API call failed:', error);
      }
    });
  }
  
  enquiry() {
    const screenWidth = window.innerWidth;
    let isSmallScreen = false;
    if (screenWidth <= 1440) {
      isSmallScreen = true;
    }
    let token = localStorage.getItem('stoken');
    if (token) {
      const dialogRef = this.dialogRef.open(EditEnquiryComponent, {
        maxHeight: '90vh',
        width: isSmallScreen ? '350px' : '700px',
        // data: {
        //   img: '../.assets/images/report.svg',
        //   heading: 'Enquiry',
        //   para: 'Lorem Ipsum is simply dummy text of the printing text of the printing. ',
        //   report: 'Yes, Logout',
        //   cancel: 'Cancel'
        // }
      });
    } else {
      this.toastr.error('Need to login first');
      this.router.navigate(['/login']);
    }
  }


  initSlick(): void {
    $('.slick-slider').each(() => {
      if ($(this).hasClass('slick-initialized')) {
        try {
          $(this).slick('unslick');
        } catch (error) {
          console.warn('Slick slider could not be unslicked:', error);
        }
      }
    });

    if ($('.testimonials-slide').hasClass('slick-initialized')) {
      $('.testimonials-slide').slick('unslick');
    }

    $('.testimonials-slide').slick({
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 3.2,
      slidesToScroll: 3,
      arrows: true,
      prevArrow: '<button type="button" class="slick-prev"><img src="assets/images/new_images/arrow-left.svg" class="" alt=""></button>',
      nextArrow: '<button type="button" class="slick-next"><img src="assets/images/new_images/arrow-right.svg" class="" alt=""></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true
          }
        }
      ]
    });


  }

   




}

